import axios from 'axios';
import type { IAppointmentPushNotificationDelivery } from '@bb/domain/dist/types';
import type { AppointmentDeliveryLog } from './getEmailDeliveryLog';

const getPushNotificationDeliveryLog = async (appointmentId: string) => {
  const { data } = await axios.get<IAppointmentPushNotificationDelivery[]>(
    `/appointment/${appointmentId}/pushNotifications`,
  );

  return data.map(log => ({
    recipient: `${log.user?.firstName} ${log.user?.lastName}`,
    eventType: log.notificationType,
    status: log.event,
    time: new Date(log.receivedAt),
  })) as AppointmentDeliveryLog[];
};

export default getPushNotificationDeliveryLog;
